<template>
  <div class="sim_servers response_table">

    <div v-if="loading" style="height: 100%">
      <h3 style="text-align: center" >
        {{translate('no_data')}}
      </h3>
    </div>

    <table v-else>
      <thead>
        <tr>
          <th scope="col">
            {{ translate('sim_server.simserver_name') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.place') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.status') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.simcard_count') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.ts_update') }}
          </th>
          <th scope="col">
            {{ translate('sim_server.ts_create') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
            v-for="(sim_server, index) in sim_servers_list"
            :key="index"
            class="sim_server_item"
            @click="show_info(sim_server.id)"
        >
          <td :data-label="translate('sim_server.simserver_name')">
            <span>{{sim_server.name }}</span>
          </td>
          <td :data-label="translate('sim_server.place')">
            <span>{{sim_server.place }}</span>
          </td>
          <td :data-label="translate('sim_server.status')">
            <span>{{sim_server.status }}</span>
          </td>
          <td :data-label="translate('sim_server.simcard_count')">
              <span>{{sim_server.simcard_count}}</span>
          </td>
          <td :data-label="translate('sim_server.ts_update')">
            <span>{{ get_date(sim_server.ts_update) }}</span>
          </td>
          <td :data-label="translate('sim_server.ts_create')">
            <span>{{ get_date(sim_server.ts_create) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
   

  </div>
</template>

<script>


export default {
  name: 'SimServers',
  props: {
    request: {
      type: String,
      default: 'all'
    }
  },

  data () {
    return {
      loading: true,
      sim_servers_list: {}
    }
  },

  created () {
    this.get_sim_servers()
  },

  methods: {
    get_sim_servers(){
      this.$http.simcard.getSimServers((response) => {
        this.sim_servers_list = response.data
        this.loading = false
      })
    }
  },
}
</script>
<style lang='scss' scoped>
  .sim_servers{
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
 </style>
